import PageShell from "./PageShell";
import Services from "../components/landing/Services";
import ProgramsCompact from "../components/landing/ProgramsCompact";
import WhyUs from "../components/landing/WhyUs";

const CoachingPage = () => (
  <PageShell title="Coaching">
    <Services />
    <ProgramsCompact />
    <WhyUs />
  </PageShell>
);

export default CoachingPage;
